import * as THREE from "three";
import { MathUtils, MeshStandardMaterial } from "three";
var degToRad = MathUtils.degToRad;
import { pillarColorGray, threeAxisLedAlpha, threeAxisLedAlphaRotated } from "../assets/materials";
var LightType;
(function (LightType) {
    LightType[LightType["SPOT"] = 0] = "SPOT";
    LightType[LightType["LINEAR"] = 1] = "LINEAR";
    LightType[LightType["THREEAXIS"] = 2] = "THREEAXIS";
})(LightType || (LightType = {}));
export class PvcLedLightsExtra {
    constructor(scene) {
        this.scene = scene;
    }
    createPVCLights(positions, color, rotation = 0, coral = false) {
        if (this.scene.formData.extras.spotLed === true) {
            this.createPVCLight(positions, rotation, color, coral, LightType.SPOT);
        }
        else if (this.scene.formData.extras.threeAxisLed) {
            this.createPVCLight(positions, rotation, color, coral, LightType.THREEAXIS);
        }
        else if (this.scene.formData.extras.linearLed) {
            this.createPVCLight(positions, rotation, color, coral, LightType.LINEAR);
        }
    }
    createPVCLight(positions, rotation, color, coral, lightType) {
        const length = this.scene.formData.measuredModel.width - this.scene.formData.measuredModel.model.edgeWidth * 2;
        const scale = new THREE.Vector3(1, 1, 1);
        const horizontalLeds = Math.round(length / 80);
        // Rotate to fit the slope
        let rotateLight = new THREE.Quaternion();
        if (coral === true)
            rotateLight.setFromEuler(new THREE.Euler(0, 0, degToRad(-10)));
        let mesh;
        /** Render the different types of lamps **/
        switch (lightType) {
            case LightType.SPOT:
                {
                    const geom = new THREE.CylinderGeometry(3, 3, 7);
                    const mat = new THREE.MeshBasicMaterial({ color: 0xF9F8D3 });
                    const sideMat = new MeshStandardMaterial({
                        color: color,
                        map: pillarColorGray
                    });
                    const materials = [
                        sideMat, sideMat, mat
                    ];
                    mesh = new THREE.InstancedMesh(geom, materials, positions.length / 2 * horizontalLeds);
                }
                break;
            case LightType.THREEAXIS:
                {
                    const geom = new THREE.BoxGeometry(3, 3, 15);
                    const mat = new THREE.MeshBasicMaterial({
                        color: 0xF9F8D3,
                        alphaMap: threeAxisLedAlpha,
                        transparent: true,
                        polygonOffset: true,
                        polygonOffsetFactor: -1.0,
                    });
                    const matFront = new THREE.MeshBasicMaterial({
                        color: 0xF9F8D3,
                        alphaMap: threeAxisLedAlphaRotated,
                        transparent: true,
                        polygonOffset: true,
                        polygonOffsetFactor: -1.0,
                    });
                    const materials = [
                        mat, mat, matFront, matFront, mat, mat
                    ];
                    mesh = new THREE.InstancedMesh(geom, materials, positions.length / 2 * horizontalLeds * 3);
                }
                break;
            case LightType.LINEAR: {
                const geom = new THREE.BoxGeometry(3, 3, 15);
                const mat = new THREE.MeshBasicMaterial({
                    color: 0xF9F8D3,
                    polygonOffset: true,
                    polygonOffsetFactor: -1.0,
                });
                mesh = new THREE.InstancedMesh(geom, mat, positions.length / 2 * horizontalLeds);
            }
        }
        let y = 0;
        for (let i = 1; i <= positions.length - 1; i += 2) {
            let zPos = positions[i].z;
            zPos -= length / 2;
            if (lightType === LightType.SPOT)
                positions[i].y -= 3.5;
            else {
                positions[i].y -= 0.01;
            }
            for (let x = 1; x < horizontalLeds; x++) {
                const pos = positions[i];
                pos.z = zPos + (length / horizontalLeds) * x;
                mesh.setMatrixAt(y, new THREE.Matrix4().compose(pos, rotateLight, scale));
                y++;
            }
        }
        mesh.rotateZ(MathUtils.degToRad(rotation));
        this.scene.threeScene.add(mesh);
    }
}
